import { lazy } from 'react';

const CharityVettingNIFRoute = lazy(
  () => import(/* webpackChunkName: "CharityVettingNIF" */ '../components/steps/NIF-step/NIF'),
);

export default CharityVettingNIFRoute;
